import jsPDF from 'jspdf';

import { dateTimeStr } from '#/utilities';

import logo from './footer-logo.png';
import { drawMarks, drawSeparationLine } from './helpers';
import * as style from './style';
import { DateSubsection } from './types';

export const generateFootersAndMarks = (
  doc: jsPDF,
  vesselName?: string,
  signingUser?: string,
  dateSubsections?: DateSubsection[],
  gatewayVersion?: string,
  opts: { documentWidth: number; documentHeight: number } = {
    documentWidth: style.DOCUMENT_WIDTH,
    documentHeight: style.DOCUMENT_HEIGHT,
  },
): void => {
  let pageCounterForSubsection = 0;
  let currentSubsectionIndex = 0;
  const totalNumberOfPages = doc.getNumberOfPages();
  for (let page = 1; page < totalNumberOfPages + 1; page++) {
    if (dateSubsections) {
      if (page <= dateSubsections[currentSubsectionIndex].endPage) {
        pageCounterForSubsection++;
      } else {
        pageCounterForSubsection = 1;
        currentSubsectionIndex++;
      }
    }
    doc.setPage(page);
    drawMarks(doc);
    drawSeparationLine(doc, {
      y: opts.documentHeight - style.SEPARATION_LINE_FOOTER_Y_OFFSET_BOTTOM,
      color: style.SEPARATION_LINE_COLOR,
      skipNewPageCheck: true,
      documentWidth: opts.documentWidth,
    });
    doc.setFont(style.FOOTER_FONT_TYPE);
    doc.setFontSize(style.FOOTER_FONT_SIZE);
    doc.setTextColor(style.FOOTER_FONT_COLOR);
    let pageCounterText = `page ${doc.getCurrentPageInfo().pageNumber}/${totalNumberOfPages}`;
    if (dateSubsections) {
      pageCounterText = `date: ${dateSubsections[currentSubsectionIndex].date}\npage of date ${pageCounterForSubsection}/${dateSubsections[currentSubsectionIndex].noOfPages}\n${pageCounterText}`;
    }
    doc.text(
      pageCounterText,
      opts.documentWidth - style.CONTENT_MARGIN_RIGHT,
      opts.documentHeight - style.FOOTER_Y_OFFSET_BOTTOM,
      {
        align: 'right',
      },
    );
    let leftFooterText = `Exported at: ${dateTimeStr()}`;
    if (signingUser) {
      leftFooterText += `\nExported by: ${signingUser}`;
    }
    if (vesselName) {
      leftFooterText += `\n${vesselName}`;
    }
    if (gatewayVersion) {
      leftFooterText += `\neLog version: ${gatewayVersion}`;
    }
    doc.text(leftFooterText, style.CONTENT_MARGIN_LEFT, opts.documentHeight - style.FOOTER_Y_OFFSET_BOTTOM);

    const signatureMarginRight = Math.max(...pageCounterText.split('\n').map((line) => doc.getTextWidth(line)));
    addSignatureHolder(doc, signatureMarginRight, opts);
    doc.addImage(
      logo,
      'PNG',
      style.CONTENT_MARGIN_LEFT + (opts.documentWidth - style.CONTENT_MARGIN_X - style.LOGO_WIDTH) / 2,
      opts.documentHeight - style.LOGO_Y_OFFSET_BOTTOM,
      style.LOGO_WIDTH,
      style.LOGO_HEIGHT,
    );
  }
};

const addSignatureHolder = (
  doc: jsPDF,
  marginRight: number,
  opts: { documentWidth: number; documentHeight: number },
) => {
  doc.setFont(style.FOOTER_FONT_TYPE);
  doc.setFontSize(style.FOOTER_FONT_SIZE);
  doc.setTextColor(style.FOOTER_FONT_COLOR);
  const signHolderText = 'Signature of master';
  const signatureHolderPositionX =
    style.CONTENT_MARGIN_LEFT + (opts.documentWidth - style.CONTENT_MARGIN_X + style.LOGO_WIDTH) / 2 + 3;
  const signatureHolderPositionY = opts.documentHeight - style.FOOTER_Y_OFFSET_BOTTOM + 10;
  doc.line(
    signatureHolderPositionX,
    signatureHolderPositionY - 3,
    opts.documentWidth - style.CONTENT_MARGIN_RIGHT - marginRight,
    signatureHolderPositionY - 3,
  );
  doc.text(signHolderText, signatureHolderPositionX, signatureHolderPositionY);
};
